



















import { Component } from "vue-property-decorator";

import PrivacyPolicyCpt from "./PrivacyPolicyCpt.vue";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    PrivacyPolicyCpt,
  },
})
export default class AuthStatusCpt extends AppVue {
  isPrivacyPolicyVisible = false;

  async logout() {
    await this.$msal.logout();

    this.notify("Success", "You are now logged out.", "success");

    this.$router.push("/login");
  }

  openPrivacyPolicy() {
    this.isPrivacyPolicyVisible = true;
  }
}
